import { createSlice } from "@reduxjs/toolkit";
import {
  getColor,
} from "./colorService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  colorList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const colorSlice = createSlice({
  name: "color",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Color List ---------- */
    builder
      .addCase(getColor.pending, (state) => {
        state.colorList.status = STATUS.LOADING;
        state.colorList.error = null;
      })
      .addCase(getColor.fulfilled, (state, action) => {
        state.colorList.status = STATUS.SUCCEEDED;
        state.colorList.data = action?.payload?.data || [];
      })
      .addCase(getColor.rejected, (state, action) => {
        state.colorList.status = STATUS.FAILED;
        state.colorList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectColorList = (state) =>
  state.color.colorList;

export default colorSlice.reducer;
